<!--
  2021-06-27 C007 Add for share
-->
<template>
  <div>
    <div v-if="isVIR" class="VIRPage"
         :style="{backgroundImage:'url('+require('../../assets/images/cashWheel/sharePage.webp')+')'}">
      <div class="barbg">
        <div class="bar"></div>
      </div>
    </div>
    <div v-else>
      <div class="page" @click="start">
        <div class="top-btn" v-show="imgShow">{{ $t('lang.betActivityRegularly.claimNow') }}</div>
        <img :src="inviteBg" alt="WebP Image" class="inviteBg" @load="imageLoaded"/>
        <div class="start-btn" v-show="imgShow">
          <!--          <span>Claim immediately</span>-->
          <span>{{ $t('lang.share.getNow') }}</span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {LogUtils} from '@/utils'
import request from '@/service'

export default {
  name: 'shareB',
  data () {
    return {
      isVIR: false,
      userInfo: null,
      imgShow: false,
      inviteBg: require('@/assets/images/common/invitebg4.webp'),
      shareCode: 'testShareCode'
    }
  },
  mounted () {
    this.extractUrlParams()
    let shareCode = this.$route.query.s
    LogUtils.setShareCode(shareCode)
    this.shareCode = shareCode
    if (window.location.href.indexOf('f=n') > -1) {
      localStorage.setItem('shareType', 'verjaardag')
    }
    this.saveUserEvent('InSharePage')
  },
  methods: {
    imageLoaded () {
      this.imgShow = true
    },
    // 解析地址参数
    extractUrlParams () {
      let url = window.location.href
      // 创建一个空对象来存储参数
      const params = {}
      // 使用 '?' 分割URL和查询字符串
      const queryString = url.split('?')[1]
      if (!queryString) {
        // 如果没有查询字符串，返回空对象
        return params
      }
      // 使用 '&' 分割每个参数
      const pairs = queryString.split('&')
      // 遍历每个参数对
      pairs.forEach(pair => {
        // 使用 '=' 分割参数名和参数值
        const [key, value] = pair.split('=')
        // 将解码后的参数名和参数值添加到params对象中
        params[decodeURIComponent(key)] = decodeURIComponent(value)
      })
      if (params.shareType && params.shareType.includes('VIR')) {
        this.isVIR = true
        localStorage.setItem('shareVIRData', JSON.stringify(params))
        setTimeout(() => {
          this.$router.push('/cashWheel')
        }, 3000)
      }
      return params
    },
    start () {
      this.saveUserEvent('ShareStart')
      this.$router.push('/login')
    },
    getUrlParams (param) {
      const searchParams = new URLSearchParams(window.location.search)
      return searchParams.get(param)
    },
    // 埋点
    saveUserEvent (val) {
      const url = '/innovation/account/save/user/event'
      const data = {EventNameEN: val, Param2: this.shareCode}
      request('post', url, data, true).then(res => {
        if (!this.isVIR) {
          // this.start()
        }
      }).catch(err => {
        this.start()
        console.log(err)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.VIRPage {
  height: 205.555vw;
  width: 100vw;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: fixed;
  overflow: hidden;

  .barbg {
    position: absolute;
    bottom: 55vw;
    left: 5vw;
    width: 91vw;
    height: 3vw;
    background-color: #fff;
    border-radius: 5vw;
    @keyframes loading {
      0% {
        width: 0%;
      }
      100% {
        width: 100%;
      }
    }

    .bar {
      border-radius: 5vw;
      height: 3vw;
      background-color: #0fabff;
      animation: loading 3s linear forwards;
    }
  }
}

.page {
  position: fixed;
  width: 100vw;
  height: 100dvh;
  top: 0;
  left: 0;
  background: #0C0302;
  overflow-x: hidden;
  overflow-y: auto;

  .top-btn {
    position: absolute;
    top: 5.277vw;
    right: 6.0166vw;
    text-transform: capitalize;
    background: #FFFFFF;
    width: 37.686vw;
    height: 9.95vw;
    line-height: 9.95vw;
    border-radius: 1.388vw;
    text-align: center;
    font-size: 4.722vw;
    font-weight: 700;
    color: #000000;
    background: linear-gradient(90.85deg, #EFD6AD -10.06%, #DAB67C 116.71%);
    animation: pulse 0.3s infinite alternate;
  }

  .inviteBg {
    width: 100vw;
    height: auto;
  }

  .start-btn {
    margin: 2.5vw auto 0 auto;
    width: 85.833vw;
    height: 13.055vw;
    line-height: 13.055vw;
    text-align: center;
    background: linear-gradient(to right, rgba(239, 214, 173, 1), rgba(218, 182, 124, 1));
    border-radius: 1.3888vw;
    font-size: 6.388vw;
    font-weight: 700;
    color: #000000;
    animation: pulse 0.3s infinite alternate;
    position: absolute;
    left: 7vw;
    top: 176vw;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.84);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes pulse2 {
    0% {
      transform: scale(0.92127);
    }
    100% {
      transform: scale(1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Share/share.vue